import { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/prime.css";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import axios from "axios";
import { showSwalError } from "../../utilities/swal";
import "./filter.scss"

export default function Filter({
  updateFilteredUsers,
  Labels,
  Pages,
  setFilterKey,
  FilterSend,
  setDates,
  setFilter,
  dates,
  filter
}) {
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [purchaseCreditTo, setPurchaseCreditTo] = useState("");
  const [purchaseCreditFrom, setPurchaseCreditFrom] = useState("");
  // const [Labels, setLabels] = useState([]);
  const [Info, setInfo] = useState([]);
 

  useEffect(() => {
    // axios
    //   .post("http://mvc.dade24.ir/api/Find_user_tags")
    //   .then(({ data }) => {
    //     let array = [];
    //     data.forEach((element) => {
    //       array.push({ value: `${element.id}`, label: `${element.title}` });
    //     });
    //     setLabels(array);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }, []);

  return (
    <>
      <div
        className="modal fade filter-modal"
        id="FilterModal"
        tabindex={-1}
        aria-labelledby="filterBtn"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="send-messageLabel">
                جستجو کاربران{" "}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="filter-ctn ">
                <label htmlFor="full-name mb-2">نوع :</label>
                <select
                  className="form-select mt-1 mb-3"
                  value={filter.user_type}
                  onChange={(e) =>
                    setFilter({ ...filter, ["user_type"]: e.target.value })
                  }
                >
                  <option selected></option>
                  <option value="1">مدیریت</option>
                  <option value="2">تور لیدر</option>
                  <option value="3">مشتری</option>
                </select>

                <label htmlFor="full-name mb-2">وضعیت :</label>
                <select
                  className="form-select mt-1 mb-3"
                  value={filter.mainstatus}
                  onChange={(e) =>
                    setFilter({ ...filter, ["mainstatus"]: e.target.value })
                  }
                >
                  <option selected></option>
                  <option value="0">عادی</option>
                  <option value="1">فعال</option>
                  <option value="2">مسدود</option>
                </select>

                <label htmlFor="first-name">نام :</label>
                <input
                  type="text"
                  className="form-control mt-1 mb-3"
                  id="first-name"
                  value={filter.fname}
                  onChange={(e) =>
                    setFilter({ ...filter, ["fname"]: e.target.value })
                  }
                />
                <label htmlFor="last-name">نام خانوادگی :</label>
                <input
                  type="text"
                  className="form-control mt-1 mb-3"
                  id="last-name"
                  value={filter.lname}
                  onChange={(e) =>
                    setFilter({ ...filter, ["lname"]: e.target.value })
                  }
                />
                <label htmlFor="phone-number" className="mt-1">
                  شماره همراه:
                </label>
                <input
                  type="text"
                  className="form-control mt-1 mb-3"
                  id="phone-number"
                  value={filter.mobile}
                  onChange={(e) =>
                    setFilter({ ...filter, ["mobile"]: e.target.value })
                  }
                />
                {/* <label htmlFor="purchase-credit-from">اعتبار خرید از:</label> */}
                {/* <input type="text" className="form-control mt-1 mb-3" id="purchase-credit-from" value={purchaseCreditFrom} onChange={(e) => setPurchaseCreditFrom(e.target.value)} /> */}
                {/* <label htmlFor="purchase-credit-to" className="mt-1">
                اعتبار خرید تا:
              </label> */}
                {/* <input type="text" className="form-control mt-1 mb-3" id="purchase-credit-to" value={purchaseCreditTo} onChange={(e) => setPurchaseCreditTo(e.target.value)} /> */}
                <label htmlFor="labels" className="mt-1">
                  برچسب ها:
                </label>
                {Labels == [] ? null : (
                  <CreatableSelect
                    isMulti
                    placeholder={"انتخاب"}
                    options={Labels}
                    onChange={(lables) => {
                      let array = [];
                      lables.forEach((element) => {
                        array.push(element.value);
                      });
                      setFilter({
                        ...filter,
                        ["user_tags_ids"]: array.toString(),
                      });
                    }}
                    className="mt-1 mb-3"
                  />
                )}
                <label htmlFor="Code">کد ملی :</label>
                <input
                  type="number"
                  className="form-control mt-1 mb-3 text-start"
                  id="Code"
                  value={filter.codemelli}
                  onChange={(e) =>
                    setFilter({ ...filter, ["codemelli"]: e.target.value })
                  }
                />

                <label htmlFor="date">زمان ثبت نام :</label>

                <DatePicker
                  calendar={persian}
                  range
                  id="date"
                  // mainPosition="bottom"
                  locale={persian_fa}
                  // placeholder="محدوده"
                  // fixMainPosition={true}
                  value={dates}
                  containerClassName="w-100"
                  className=" w-100 "
                  onChange={(dateObjects) => {
                    setDates(dateObjects);
                    if (dateObjects.length == 2) {
                      setFilter({
                        ...filter,
                        ["frommtm"]: dateObjects[0].unix,
                        ["tomtm"]: dateObjects[1].unix,
                      });
                    }
                  }}
                  plugins={[<DatePanel />]}
                  style={{
                    backgroundColor: "white",
                    border: "1px solid #cbc7c7",
                    borderRadius: "4px",
                  }}
                  arrowStyle={{ width: "20px" }}
                />
                {/* <button
                className="btn btn-primary"
                style={{ marginTop: "30px" }}
                onClick={() => {
                  filterUsers();
                }}
              >
                اعمال فیلتر
              </button> */}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                انصراف
              </button>
              <button
                data-bs-dismiss="modal"
                aria-label="Close"
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  FilterSend("iscustomer",1,0,filter,dates);
                  FilterSend("isadmin",1,1,filter,dates);
                  setFilterKey(true);
                  
                }}
              >
                فیلتر
              </button>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </>
  );
}
